'use client'

import type { LenisOptions } from 'lenis'
import { type ComponentProps, useEffect } from 'react'
import type { Theme } from '~/styles/config'
import { Canvas } from '~/webgl/components/canvas'
import { Lenis } from '../lenis'

interface WrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  theme?: Theme
  lenis?: boolean | LenisOptions
  webgl?: boolean | Omit<ComponentProps<typeof Canvas>, 'children'>
}

export function Wrapper({
  children,
  theme = 'dark',
  lenis = true,
  webgl,
}: WrapperProps) {
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme)
  }, [theme])

  return (
    <>
      {webgl && <Canvas root {...(typeof webgl === 'object' && webgl)} />}
      {children}
      <script>
        {`document.documentElement.setAttribute('data-theme', '${theme}');`}
      </script>
      {lenis && <Lenis root options={typeof lenis === 'object' ? lenis : {}} />}
    </>
  )
}
